
import {ITEMS} from './navbar-items.js'
import MenuExpanded from './menu-expanded.vue'

export default {
  components: {
    MenuExpanded
  },
  data() {
    return {
      items: ITEMS,
      open: false,
    }
  },
  computed: {
    c_items() {
      return this.items.filter(item => item.allow_mobile)
    },
  },
  methods: {
    toggleBurger() {
      this.open = !this.open
    }
  }
}
